import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("csp_token");
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("csp_token");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("csp_token", data.token);
    const u = { ...data.user, needs_password_change: data.needs_password_change };
    setUser(u);
    return u;
  };

  const setInitialPassword = async (currentPassword, newPassword) => {
    const { data } = await api.post("/auth/set-initial-password", {
      current_password: currentPassword, new_password: newPassword,
    });
    localStorage.setItem("csp_token", data.token);
    const u = { ...data.user, needs_password_change: false };
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem("csp_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setInitialPassword }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
